<template>
  <div>
    <div class="text-left">
      <b-card title="Bitte legen Sie die Bestellung an:">
        <p>Das Anlegen der Bestellung dauert einen Moment. Bitte schließen Sie nicht das Fenster.</p>
        <b-button
            type="submit"
            variant="primary"
            @click="transferOrder"
            :disabled="orderSubmittingInProgress">
          <b-spinner v-if="orderSubmittingInProgress"  small label="Loading..."></b-spinner>
          Bestellung anlegen
        </b-button>
      </b-card>
    </div>
  </div>
</template>

<script>

import ProductSummary from "@/views/checkout/summary/ProductSummary";
import AddressSummary from "@/views/checkout/summary/AddressSummary";
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {required, email, digits} from '@validations'

import {
  BCard,
  BCol,
  BRow,
  BForm,
  BButton, BSpinner,
} from "bootstrap-vue";
import {mapGetters} from "vuex";

export default {
  name: "CheckoutSummary",
  components: {
    AddressSummary,
    ProductSummary,
    BCard,
    BRow,
    BCol,
    BForm,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      load_order_summary: false,
      terms_and_conditions: false,
      privacy: false,
      order_summary_downloaded: false,
      order_summary_received: false,
      revocation: false,
      orderSubmittingInProgress: false,
      submitOrderHasAnError: false
    }
  },
  computed: {
    ...mapGetters(['SERVICE', 'CHECKOUT_DATA', 'ORDER_STEPS_CURRENT', 'ORDER_STEPS_TOTAL', 'PRODUCT_ADDRESS', 'IS_EMPLOYEE', 'CAPTURE_METHOD', 'ADDRESS']),
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(price / 100)
    },
    formatDate(datestring) {
      let date = new Date(datestring)

      return date.toLocaleDateString('de-DE')
    },
    hasPhonebookEntries() {
      let entries = this.CHECKOUT_DATA.phoneline.phonebook.filter(entry => entry.selected)

      return entries.length > 0
    },
    transferOrder() {
      this.CHECKOUT_DATA.serviceOptions = []
      this.CHECKOUT_DATA.serviceOptions = this.CHECKOUT_DATA.serviceOptions

      let services = [];

      Object.keys(this.CHECKOUT_DATA.internetOptions).forEach((key) => {
        services = services.concat(this.CHECKOUT_DATA.internetOptions[key])
      })
      Object.keys(this.CHECKOUT_DATA.phoneOption).forEach((key) => {
        services = services.concat(this.CHECKOUT_DATA.phoneOption[key])
      })
      Object.keys(this.CHECKOUT_DATA.phoneOptions).forEach((key) => {
        if (this.CHECKOUT_DATA.phoneOptions[key].description === 'Zusätzlicher Sprachkanal' && this.CHECKOUT_DATA.countVoiceChannels > 1) {
          for (let i = 1; i <= this.CHECKOUT_DATA.countVoiceChannels; i++) {
            services = services.concat(this.CHECKOUT_DATA.phoneOptions[key])
          }
        } else {
          services = services.concat(this.CHECKOUT_DATA.phoneOptions[key])
        }
      })
      Object.keys(this.CHECKOUT_DATA.payTVOptions).forEach((key) => {
        services = services.concat(this.CHECKOUT_DATA.payTVOptions[key])
      })
      Object.keys(this.CHECKOUT_DATA.flatratesOptions).forEach((key) => {
        services = services.concat(this.CHECKOUT_DATA.flatratesOptions[key])
      })
      Object.keys(this.CHECKOUT_DATA.tvServiceOption).forEach((key) => {
        services = services.concat(this.CHECKOUT_DATA.tvServiceOption[key ])
      })

      this.CHECKOUT_DATA.serviceOptions = this.CHECKOUT_DATA.serviceOptions.concat(services);

      this.CHECKOUT_DATA.serviceOptions.forEach((serviceOptionItem) => {
        if (serviceOptionItem.description === 'Zusätzlicher Sprachkanal' && this.CHECKOUT_DATA.countVoiceChannels > 1) {
          for (let i = 1; i < this.CHECKOUT_DATA.countVoiceChannels; i++) {
            this.CHECKOUT_DATA.serviceOptions.push(serviceOptionItem)
          }
        }
      })

      if (this.CHECKOUT_DATA.hardwareOptions.length !== 0) {
        this.CHECKOUT_DATA.serviceOptions.push(this.CHECKOUT_DATA.hardwareOptions)
      }

      this.orderSubmittingInProgress = true

      let data = {
        id: this.SERVICE.id,
        tenant: this.SERVICE.tenant,
        checkoutData: this.CHECKOUT_DATA,
        service: this.SERVICE,
        serviceOptions: this.CHECKOUT_DATA.serviceOptions,
        address: this.PRODUCT_ADDRESS,
        isemployee: this.IS_EMPLOYEE,
        capture_method: this.CAPTURE_METHOD,
      }

      data.checkoutData.funnel_v2 = this.ADDRESS.funnel_v2

      if (this.CHECKOUT_DATA.appointment == 2) {
        data.appointment_date = this.CHECKOUT_DATA.appointment_date
      }

      this.$http.post('/orders', data).then(response => {
        this.orderSubmittingInProgress = false

        if (response.data.error) {
          this.submitOrderHasAnError = true
        } else {
          this.$router.push(
              {
                name: 'orders-view',
                params: {id: response.data.order.id}
              },
              () => setTimeout(() => {
                this.$bvToast.toast(('Bestellung erstellt.'), {
                  title: ('Erfolgreich'),
                  variant: 'success',
                  toaster: 'b-toaster-bottom-right'
                })
              })
          )
        }
      })
    },
  },
  mounted() {
    if (this.IS_EMPLOYEE) {
      this.terms_and_conditions = true
      this.privacy = true
      this.revocation = true
    }
  },
  beforeMount() {
    if (!this.SERVICE || !this.CHECKOUT_DATA) {
      this.$router.push({name: 'orders-add'})
    }

    this.$store.commit('SET_ORDER_STEPS_CURRENT', 3)
  }
}
</script>

<style scoped>

</style>
